import { render, staticRenderFns } from "./admin-personal.vue?vue&type=template&id=266b303a&"
import script from "./admin-personal.vue?vue&type=script&lang=js&"
export * from "./admin-personal.vue?vue&type=script&lang=js&"
import style0 from "./admin-personal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/administracion-frontend/administracion-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266b303a')) {
      api.createRecord('266b303a', component.options)
    } else {
      api.reload('266b303a', component.options)
    }
    module.hot.accept("./admin-personal.vue?vue&type=template&id=266b303a&", function () {
      api.rerender('266b303a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/components/admin-personal/admin-personal.vue"
export default component.exports